import { render, staticRenderFns } from "./CategoryEditDialog.vue?vue&type=template&id=707b36d0"
import script from "./CategoryEditDialog.vue?vue&type=script&lang=js"
export * from "./CategoryEditDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports